import { render, staticRenderFns } from "./MessageItem.vue?vue&type=template&id=05f2df21&scoped=true&"
import script from "./MessageItem.vue?vue&type=script&lang=ts&"
export * from "./MessageItem.vue?vue&type=script&lang=ts&"
import style0 from "./MessageItem.vue?vue&type=style&index=0&id=05f2df21&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f2df21",
  null
  
)

export default component.exports